import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FileViewService {
	private watermarkurl=environment.urls.resume_watermark

  constructor(private http: HttpClient) { }


  convertFiletopdf(fileUrl: any) {
	const requestBody = { file_url: fileUrl };
	return this.http.post(`${this.watermarkurl}`,requestBody,{ responseType: 'text',observe: 'response' },);
}
}
